import { render } from "./TheRentalsContainer.vue?vue&type=template&id=037526d4"
import script from "./TheRentalsContainer.vue?vue&type=script&lang=js"
export * from "./TheRentalsContainer.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__